export { GeneralMessage } from './GeneralMessage';
